import { useEffect, useState } from 'react';
import { Copy, MailCheck } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { esignAPI, errMsg } from '../../lib/esignAPI';
import api from '../../lib/api';

const CAN = ['owner', 'admin', 'accountant', 'bookkeeper']; // create_edit_client
let rolePromise;
const myRole = () => (rolePromise = rolePromise || api.get('/api/me').then((r) => r.data.active_membership?.role).catch(() => null));

export const InviteEmailPill = ({ status, testId }) => (status === 'failed' || status === 'partial'
  ? <span className="rounded-full bg-destructive/10 px-2 py-0.5 text-xs font-medium text-destructive" data-testid={testId}>Sent – email failed</span>
  : status === 'sent' ? <span className="rounded-full bg-success/15 px-2 py-0.5 text-xs font-medium text-success" data-testid={testId}>Invite emailed</span> : null);

// Resend invite email / copy signing link for a letter awaiting signature. Hidden for roles without create_edit_client.
export const InviteActions = ({ letterId, onChanged, size = 'sm' }) => {
  const [role, setRole] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { myRole().then(setRole); }, []);
  if (!CAN.includes(role)) return null;
  const resend = async () => {
    setBusy(true);
    try {
      const r = await esignAPI.resendInvite(letterId);
      if (r.failed) toast.error(`Invite email failed for ${r.failed} signer(s)${r.recipients?.find((x) => x.error) ? `: ${r.recipients.find((x) => x.error).error}` : ''}`);
      else toast.success(`Invite emailed to ${r.recipients.map((x) => x.email).join(', ')}`);
      onChanged?.();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const copy = async () => {
    try {
      const { links } = await esignAPI.signingLink(letterId);
      const usable = links.filter((x) => x.url);
      if (!usable.length) { toast.error('No signing link available'); return; }
      await navigator.clipboard.writeText(usable.map((x) => (usable.length > 1 ? `${x.name}: ${x.url}` : x.url)).join('\n'));
      toast.success(usable[0].channel === 'portal' ? 'Portal signing link copied' : 'Personal signing link copied – share it only with the signer');
    } catch (e) { toast.error(errMsg(e)); }
  };
  return <>
    <Button size={size} variant="outline" disabled={busy} onClick={resend} data-testid={`esign-resend-invite-${letterId}`}><MailCheck className="mr-1 h-3.5 w-3.5" />Resend invite email</Button>
    <Button size={size} variant="ghost" onClick={copy} data-testid={`esign-copy-link-${letterId}`}><Copy className="mr-1 h-3.5 w-3.5" />Copy signing link</Button>
  </>;
};
